<template>
  <div class="container">
    <div class="title1" style="margin-top: 50px">欢迎使用</div>

    <div class="line" style="margin-top: 25px;border-radius: 99px"></div>

    <div class="title2" style="margin-top: 37px">凡星艺彩活动平台</div>

    <div class="item1" style="margin-top: 40px" @click="go('/Main')">
    </div>
    <div class="item2" style="margin-top: 30px" @click="go('/SignUpInfoList')">

    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {},
  data() {
    return {}
  },
  created() {
  },
  activated() {
    if (typeof wx !== 'undefined') {
      wx.updateShareMenu({
        withShareTicket: true,
        success: function() {},
        fail: function(err) {
          console.error('更新分享菜单失败:', err);
        }
      });
      wx.onShareAppMessage(() => ({
        title: '凡星艺彩活动平台',
        path: '/pages/index/index',
        imageUrl: '/assets/img/share-image.png'
      }));
    }
  },
  methods: {
    go(path) {
      console.log(path)
      this.$router.push(path)
      // this.$router.push('/PayInfoList')
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column !important;
  width: 100%;
  height: 100vh;
  background: linear-gradient(180deg, rgba(255, 159, 83, 0.08) 0%, rgba(255, 104, 18, 0) 100%), #FFFFFF;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
}

.title1 {
  font-size: 22px;
  font-weight: bold;
  color: #3D3D3D;
}

.title2 {
  font-size: 27px;
  font-weight: bold;
  color: #3D3D3D;
}


.item1 {
  width: 320px;
  height: 135px;
  background: url('../assets/img/index-btn1.png') no-repeat left top / auto 100%;
}

.item2 {
  width: 320px;
  height: 135px;
  background: url('../assets/img/index-btn2.png') no-repeat left top / auto 100%;
}

.item-title {
  opacity: 1;
  font-size: 24px;
  font-weight: bold;
  line-height: normal;
  color: #3D3D3D;
}

.line {
  width: 60px;
  height: 5px;
  opacity: 1;
  /* 自动布局 */
  display: flex;
  background: linear-gradient(270deg, #FF8264 0%, rgba(255, 100, 2, 0.34) 100%);
}

</style>



// WEBPACK FOOTER //
// src/routerPages/Index.vue